export default {
  emailTemplates: [],
  cms: {
    employement_type: {
      meta: {},
      items: [],
    },
    job_branches: {
      meta: {},
      items: [],
    },
    job_positions: {
      meta: {},
      items: [],
    },
    employee_number: {
      meta: {},
      items: [],
    },
    languages: {
      meta: {},
      items: [],
    },
    soft_skills: {
      meta: {},
      items: [],
    },
  },
  jobseeker_management: {
    users: [],
    total: 0,
  },
  company_management: {
    users: [],
    total: 0,
  },
  duplicateUsers: {
    items: [],
    meta: {},
  },
  duplicateJobBranches: {
    items: [],
    meta: {},
  },
};
